import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import extend from 'lodash/extend';
import { withRouter } from 'react-router';
import Ad from '../../../../components/ad/ad';
import Slug from '../../../../components/slug/slug';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import FranchiseAccordionSection from '../../../../components/franchise_accordion_section/franchise_accordion_section';

// eslint-disable-next-line
class PersonIndexSectionPage extends Component {
  constructor(props) {
    super(props);

    this.alphabet = [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'y',
      'z'
    ];
  }

  render() {
    if (this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.personIndexSectionPage.isLoading) {
      return (
        <section className="person-page">
          <article className="person-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const { personIndexSectionData, personIndexSectionNextData } = this.props;

    const adData = get(this.props, 'personIndexSectionPage.ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const pgTitle = 'person index';
    const section = get(this.props, 'match.params.section');
    const page = Number(get(this.props, 'match.params.page'));
    const nextPage =
      page && !isEmpty(personIndexSectionNextData) ? String(page + 1) : null;
    const prevPage = page > 1 ? String(page - 1) : null;

    return (
      <section className="person-index-page">
        <Ad {...combinedAdModel} name="oop" slug={false} oop={true} />
        <section className="page-title person-index-page__page-title">
          <Slug slugName={pgTitle} className="category-page" />
          <h3 className="page-description">
            A list of people in the Fast Company database. For the Most Creative
            People in Business Community, please{' '}
            <a href="https://www.fastcompany.com/most-creative-people-community">
              click here
            </a>
          </h3>
        </section>

        {this.alphabet.map(letter => (
          <FranchiseAccordionSection
            combinedAdModel={combinedAdModel}
            index={letter}
            key={letter}
            data={personIndexSectionData}
            propertyToDisplay="full_name"
            prevPage={prevPage}
            nextPage={nextPage}
            activeSection={section}
            pathForSection="person"
            pathForData="person"
          />
        ))}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    status: state.status.code,
    personIndexSectionData: get(state, 'personIndexSection.data') || {},
    personIndexSectionNextData: get(state, 'personIndexSectionNext.data') || {},
    personIndexSectionPage: Object.keys(get(state, 'personIndexPage')).length
      ? get(state, 'personIndexPage')
      : get(state, 'personIndexSectionPage') || {}
  };
}

PersonIndexSectionPage.propTypes = {
  status: PropTypes.number.isRequired,
  personIndexSectionData: PropTypes.shape({}).isRequired,
  personIndexSectionNextData: PropTypes.shape({}).isRequired,
  personIndexSectionPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(PersonIndexSectionPage));



// WEBPACK FOOTER //
// ./src/views/containers/pages/mcp/person_index_section_page/person_index_section_page.js